// /app/frontend/src/lib/adminApi.js
// Helper para llamadas a /api/admin/*. Adjunta automáticamente
// el header Authorization: Bearer <Firebase ID Token>.
import { auth } from "./firebase";

export class AdminAuthError extends Error {
  constructor(message, code) {
    super(message);
    this.code = code;
  }
}

async function getAdminToken() {
  const u = auth?.currentUser;
  if (!u) {
    throw new AdminAuthError(
      "Debes iniciar sesión como administrador",
      "NO_SESSION"
    );
  }
  // forceRefresh=false; Firebase refresca solo si está cerca de expirar
  return u.getIdToken();
}

export async function adminFetch(url, options = {}) {
  const token = await getAdminToken();
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${token}`,
  };
  if (options.body && !headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  return fetch(url, { ...options, headers });
}
